export const css = {
    root: '_2zzaj6RQ',
    input: '_32P6pG8X',
    inputWrapper: '_-1QtL2BV',
    radioBackground: 'H_HMFhWl',
    radioOuter: '_3A_jT0zH',
    radioInner: '_3BylnSwL',
    focused: '_1CEy2VKw',
    checked: '_1oNj-wM3',
    disabled: '_1NjjuBLX',
    readonly: '_3BtKM9qn',
    invalid: '_1EWKSBiU',
    valid: '_1qgT2TVf',
    ' _key': 'certwise-theme/certwise/dojo/radio'
};
export default css;
